import { Components, Theme } from '@mui/material';

export const getDrawerComponent = (
  theme: Theme,
): Pick<Components<Theme>, 'MuiDrawer'> => ({
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: theme.palette.background.paper,

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',

        width: 320,
        minWidth: 320,
        maxWidth: 512,
        height: '100%',

        boxShadow: theme.shadows[12],
      },
    },

    defaultProps: {
      transitionDuration: {
        enter: theme.transitions.duration.lelyTransition,
        exit: theme.transitions.duration.lelyTransition,
      },
    },
  },
});
